import { useContext } from "react";

import DilutionContext from "../../context/materialcapture/DilutionContext";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import SendSharpIcon from '@mui/icons-material/SendSharp';

import FormulationPicker from "./FormulationPicker";

const DilutionForm = () => {
  const { 
    dilutionData, setDilutionData, handleSubmit, formErrors, initialValues
  } = useContext(DilutionContext);

  return(
    <>
      <Grid container spacing={1} mt={1}>
        <Grid item xs={12}>
          <FormulationPicker showApplyBtn={false} />
        </Grid>

        <Grid item xs={6}>
          <Autocomplete
            value={dilutionData?.dilutionBufferId}
            onChange={(e, newValue) => 
              setDilutionData(prev => ({
                ...prev,
                dilutionBufferId: newValue
              }))
            }
            onInputChange={(e, newValue) =>
              setDilutionData(prev => ({
                ...prev,
                dilutionBufferId: newValue
              }))
            }
            options={initialValues?.dilutionBufferIdArray.map(data => data.unique_id)}
            renderInput={(params) => (
              <TextField 
                {...params} 
                label="Dilution Buffer *" 
                placeholder="Type to search Dilution Buffer ID..." 
                error={'dilutionBufferId' in formErrors}
                helperText={formErrors['dilutionBufferId']}
              />
            )}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Dilution Buffer Acronym"
            name='dilutionBufferAcronym'
            value={dilutionData?.dilutionBufferAcronym}
            fullWidth
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Dilution Factor *"
            name={'dilutionFactor'}
            value={dilutionData?.dilutionFactor}
            onChange={e => 
              setDilutionData(prev => ({
                ...prev,
                dilutionFactor: e.target.value
              }))
            }
            helperText={formErrors['dilutionFactor']}
            error={'dilutionFactor' in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Payload concentration after dilution *"
            name={'payloadConcentrationAfterDilution'}
            value={dilutionData?.payloadConcentrationAfterDilution}
            onChange={e => 
              setDilutionData(prev => ({
                ...prev,
                payloadConcentrationAfterDilution: e.target.value
              }))
            }
            helperText={
              formErrors['payloadConcentrationAfterDilution']
            }
            error={'payloadConcentrationAfterDilution' in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Volume after dilution *"
            name={'volumeAfterDilution'}
            value={dilutionData?.volumeAfterDilution}
            onChange={e => 
              setDilutionData(prev => ({
                ...prev,
                volumeAfterDilution: e.target.value
              }))
            }
            helperText={formErrors['volumeAfterDilution']}
            error={'volumeAfterDilution' in formErrors}
            type='number'
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={1} justifyContent="flex-end" mr={1}>
            <Button 
              variant="contained" 
              endIcon={<SendSharpIcon />} 
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default DilutionForm;